import React, { useContext } from 'react';
import { ProductMasterDataExportConfigurationContext } from '../../../../../context/ProductMasterDataExportConfigurationContext';
import { ExportConfigurationsPane } from '../../../../components/ExportItems';

export default function ReferenceDataExportPane() {
  const { productMasterDataExportConfigurations, productMasterDataExportConfigurationsLoading } = useContext(
    ProductMasterDataExportConfigurationContext,
  );

  return (
    <ExportConfigurationsPane
      configurations={[...productMasterDataExportConfigurations.values()]}
      loading={productMasterDataExportConfigurationsLoading}
    />
  );
}
